module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Polls',
      "size": 'md',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [(_vm.showPage && !_vm.show_poll) ? [_c('body', {
    staticClass: "px-7 py-4 flex-grow overflow-y-auto"
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('div', _vm._l((_vm.discussion_polls), function(poll, index) {
    return _c('div', {
      staticClass: "sample ellipsis-text w-full border rounded h-12 px-3 mb-2 flex items-center justify-between cursor-pointer hover:bg-gray-100",
      on: {
        "click": function($event) {
          return _vm.selectPoll(poll.id)
        }
      }
    }, [_c('p', {
      class: {
        'text-gray-400': poll.status === 'draft'
      }
    }, [_vm._v(_vm._s(poll.question || ("poll #" + (index + 1))))]), _vm._v(" "), (poll.status === 'draft') ? _c('span', {
      staticClass: "text-xs text-gray-400"
    }, [_vm._v("draft")]) : _c('span', {
      staticClass: "text-xs"
    }, [_vm._v(_vm._s(poll.votes.length) + " votes")])])
  }), 0) : _c('div', [(!_vm.discussion_polls.filter(function (p) { return p.status === 'live'; }).length) ? _c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "font-semibold pb-4"
  }, [_vm._v("There are no polls to display yet.")]), _vm._v(" "), _c('p', [_vm._v("Your teacher can create a poll on any topic and students can vote!")])]) : _c('div', _vm._l((_vm.discussion_polls.filter(function (p) { return p.status === 'live'; })), function(poll, index) {
    return _c('div', {
      staticClass: "sample ellipsis-text w-full border rounded h-12 px-3 mb-2 flex items-center justify-between cursor-pointer hover:bg-gray-100",
      on: {
        "click": function($event) {
          return _vm.selectPoll(poll.id)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(poll.question || ("poll #" + (index + 1))))]), _vm._v(" "), (_vm.getPollVoters(poll).includes(_vm.getProfile.id)) ? _c('i', {
      staticClass: "fas fa-check-circle text-primary",
      attrs: {
        "title": "Answered"
      }
    }) : _c('i', {
      staticClass: "far fa-clock text-gray-400",
      attrs: {
        "title": "Unanswered"
      }
    })])
  }), 0)])]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('footer', {
    staticClass: "flex px-7 py-5 text-center justify-center items-center"
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "sample text-white center justify-center w-40 py-2 bg-primary rounded cursor-pointer font-semibold",
    on: {
      "click": _vm.createNewPoll
    }
  }, [_c('strong', [_vm._v("New")])]) : _vm._e()]) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2fb453cf!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/polls_mvp/polls.index.vue
// module id = 1874
// module chunks = 61